import { getRuntimeState, resolveApiIfReady } from './state'
import type { BrowserWindow } from './types'

/**
 * Resets an active Turnstile widget when the browser API is ready.
 */
export const resetTurnstile = (widgetId: string | null | undefined) => {
  if (!widgetId) return
  if (typeof window === 'undefined') return
  const browserWindow = window as BrowserWindow
  const state = getRuntimeState(browserWindow)
  if (!state.activeWidgetIds.has(widgetId)) return
  const api = resolveApiIfReady()
  api?.reset?.(widgetId)
}

/**
 * Removes an active Turnstile widget and clears runtime tracking.
 */
export const removeTurnstile = (widgetId: string | null | undefined) => {
  if (!widgetId) return
  if (typeof window === 'undefined') return
  const browserWindow = window as BrowserWindow
  const state = getRuntimeState(browserWindow)
  if (!state.activeWidgetIds.has(widgetId)) return
  state.activeWidgetIds.delete(widgetId)
  const api = resolveApiIfReady()
  api?.remove?.(widgetId)
}
